
<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/2.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Our Contacts</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="">Home</a><span>Contacts</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javacript:void(0)" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<!--  section  -->
<section id="sec1" data-scrollax-parent="true">
    <div class="container">
        <!--about-wrap -->
        <div class="about-wrap">
            <div class="row">
                <div class="col-md-4">
                    <div class="ab_text-title fl-wrap">
                        <h3>Get in Touch</h3>
                        <span class="section-separator fl-sec-sep"></span>
                    </div>
                    <!--box-widget-item -->
                    <div class="box-widget-item fl-wrap block_box">
                        <div class="box-widget">
                            <div class="box-widget-content bwc-nopad">
                                <div class="list-author-widget-contacts list-item-widget-contacts bwc-padside">
                                    <ul class="no-list-style">
                                        <li><span><i class="fal fa-map-marker"></i> Address :</span> <a href="javascript:void(0);" class="custom-scroll-link address">Opp. Sp Infocity, Hadapsar, Pune, Maharashtra 412308</a></li>
                                        <li><span><i class="fal fa-envelope"></i> E-Mail :</span> <a href="mailto:businessmaharashtra@gmail.com">businessmaharashtra&#64;gmail.com</a></li>
                                    </ul>
                                </div>
                                <div class="list-widget-social bottom-bcw-box  fl-wrap">
                                    <ul class="no-list-style">
                                        <li><a href="https://www.facebook.com/bim.directory" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="https://twitter.com/businessMaharas" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="http://in.linkedin.com/in/businessinmaharashtra" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                                        <li><a href="https://www.instagram.com/businessinmaharashtra_india/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--box-widget-item end -->
                </div>
                <div class="col-md-8">
                    <div class="ab_text">
                        <div class="ab_text-title fl-wrap">
                            <h3>Business in Maharashtra</h3>
                            <span class="section-separator fl-sec-sep"></span>
                        </div>
                        <p> <strong> For Booking Advertisement, Business Promotion & Information on our Products & Services.</strong>
                            <br>
                            <i class="fal fa-envelope"></i> Write To : <a href="mailto:businessmaharashtra@gmail.com">businessmaharashtra&#64;gmail.com</a> 
                        </p>

                        <p><strong> For your valuable Suggestions & Feedback, on our Advertisement, Products and Services.</strong>
                            <br>
                            <i class="fal fa-envelope"></i> Write To : <a href="mailto:support@businessinmaharashtra.com">support&#64;businessinmaharashtra.com</a> 
                        </p>

                        <div id="contact-form">
                            <form class="form-edit custom-form w-75" [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
                                <fieldset>
                                    <label><i class="fal fa-user"></i></label>
                                    <input type="text" name="name" formControlName='name' placeholder="Your Name *" value="" />
                                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="form-text text-danger text-start">
                                        <div *ngIf="name.errors?.['required']">Name is required.</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <label><i class="fal fa-envelope"></i>  </label>
                                    <input type="text" name="email" formControlName='email' placeholder="Email Address*" value="" />
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)" class="form-text text-danger text-start">
                                        <div *ngIf="email.errors?.['required']">Email is required.</div>
                                        <div *ngIf="email.errors?.['email']">Email should be valid</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <label><i class="far fa-phone"></i>  </label>
                                    <input type="text" name="phone" formControlName='phone' placeholder="Phone Number*" value="" />
                                    <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="form-text text-danger text-start">
                                        <div *ngIf="phone.errors?.['required']">Phone is required.</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <label><i class="fal fa-map-marker"></i>  </label>
                                    <input type="text" name="address" formControlName='address' placeholder="Your Address*" value="" />
                                    <textarea name="comments" formControlName='message' cols="40" rows="3" placeholder="Your Message:"></textarea>
                                    <div *ngIf="message.invalid && (message.dirty || message.touched)" class="form-text text-danger text-start">
                                        <div *ngIf="message.errors?.['required']">Requirements detail is required.</div>
                                    </div>
                                </fieldset>
                                <button class="btn btn-primary">Send Message<i class="fal fa-paper-plane"></i></button>
                            </form>
                        </div>
                        <!-- contact form  end-->
                    </div>
                </div>
            </div>
        </div>
        <!-- about-wrap end  -->
    </div>
</section>
<section class="no-padding-section">
    <div class="map-container">
        <div id="singleMap" data-latitude="18.489528" data-longitude="73.950043" data-mapTitle="BIM Hub">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3867257.0448473636!2d76.7751435!3d18.8151606!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeff7d480aff01142!2sBusiness%20in%20Maharashtra!5e0!3m2!1sen!2sin!4v1582813664996!5m2!1sen!2sin" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </div>
    </div>
</section>